import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import Link from 'flarum/common/components/Link';
import Form from 'flarum/common/components/Form';
import Alert from 'flarum/common/components/Alert';
import Stream from 'flarum/common/utils/Stream';
import TypeFactory from '../types/TypeFactory';
import sortFields from '../../common/utils/sortFields';
export default class ProfileConfigurePane extends Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "loading", false);
    _defineProperty(this, "enforceProfileCompletion", app.forum.attribute('masquerade.force-profile-completion') || false);
    _defineProperty(this, "profileCompleted", app.forum.attribute('masquerade.profile-completed') || false);
    _defineProperty(this, "answerStreams", new Map());
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.load();
  }
  view() {
    return m("form", {
      class: "ProfileConfigurePane",
      onsubmit: this.update.bind(this)
    }, m(Form, null, this.enforceProfileCompletion && !this.profileCompleted && m(Alert, {
      type: "error",
      dismissible: false
    }, app.translator.trans('fof-masquerade.forum.alerts.profile-completion-required')), sortFields(app.store.all('masquerade-fields')).map(field => {
      return this.field(field);
    }), m(Button, {
      type: "submit",
      className: "Button Button--primary",
      loading: this.loading,
      disabled: !this.isChanged()
    }, app.translator.trans('fof-masquerade.forum.buttons.save-profile'))));
  }
  field(field) {
    if (!this.answerStreams.has(field.id())) return null;
    const type = TypeFactory.typeForField({
      field,
      stream: this.answerStreams.get(field.id())
    });
    return type.editorField();
  }
  isChanged() {
    if (!this.profileCompleted) return true;
    const answers = this.attrs.user.masqueradeAnswers() || [];
    for (const [fieldId, stream] of this.answerStreams) {
      const originalAnswer = answers.find(a => a.field()?.id() === fieldId);
      const originalValue = originalAnswer?.content() || '';
      if (stream() !== originalValue) {
        return true;
      }
    }
    return false;
  }
  async load() {
    let answers = this.attrs.user.masqueradeAnswers();
    if (answers === false) {
      this.loading = true;
      await app.store.find('users', this.attrs.user.id(), {
        include: 'masqueradeAnswers'
      });
      answers = this.attrs.user.masqueradeAnswers();
    }
    app.store.all('masquerade-fields').forEach(field => {
      const answer = answers.find(answer => answer.field()?.id() === field.id());
      this.answerStreams.set(field.id(), Stream(answer?.content() || ''));
    });
    this.loading = false;
    m.redraw();
  }
  update(e) {
    e.preventDefault();
    this.loading = true;
    const payload = {};
    for (const [key, stream] of this.answerStreams) {
      payload[key] = stream();
    }
    app.request({
      method: 'POST',
      url: app.forum.attribute('apiUrl') + '/masquerade-answers/configure/' + this.attrs.user.id(),
      body: payload
    }).then(res => {
      app.store.pushPayload(res);
      if (!this.profileCompleted) {
        this.profileCompleted = true;
        app.alerts.show({
          type: 'success'
        }, app.translator.trans('fof-masquerade.forum.alerts.profile-completed', {
          a: m(Link, {
            href: app.route('index')
          })
        }));
      }
    }).finally(() => {
      this.loading = false;
      m.redraw();
    });
  }
}
flarum.reg.add('fof-masquerade', 'forum/panes/ProfileConfigurePane', ProfileConfigurePane);